var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10819_13451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0017 30.0033C23.2869 30.0033 30.0033 23.2869 30.0033 15.0017C30.0033 6.71647 23.2869 0 15.0017 0C6.71647 0 0 6.71647 0 15.0017C0 23.2869 6.71647 30.0033 15.0017 30.0033Z",
    fill: "#FF8500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9818 25.9323C20.8656 25.9323 25.6354 21.1625 25.6354 15.2786C25.6354 9.3948 20.8656 4.625 14.9818 4.625C9.09792 4.625 4.32812 9.3948 4.32812 15.2786C4.32812 21.1625 9.09792 25.9323 14.9818 25.9323Z",
    fill: "#EF7700",
    stroke: "#CAFFEF",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.149 20.4386C14.0684 20.4386 14.8136 19.6934 14.8136 18.774C14.8136 17.8547 14.0684 17.1094 13.149 17.1094C12.2297 17.1094 11.4844 17.8547 11.4844 18.774C11.4844 19.6934 12.2297 20.4386 13.149 20.4386Z",
    fill: "#CAFFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1412 18.7746C20.0605 18.7746 20.8058 18.0293 20.8058 17.1099C20.8058 16.1906 20.0605 15.4453 19.1412 15.4453C18.2218 15.4453 17.4766 16.1906 17.4766 17.1099C17.4766 18.0293 18.2218 18.7746 19.1412 18.7746Z",
    fill: "#CAFFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4849 15.4465C12.4043 15.4465 13.1496 14.7012 13.1496 13.7818C13.1496 12.8625 12.4043 12.1172 11.4849 12.1172C10.5656 12.1172 9.82031 12.8625 9.82031 13.7818C9.82031 14.7012 10.5656 15.4465 11.4849 15.4465Z",
    fill: "#CAFFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4771 13.7824C18.3965 13.7824 19.1418 13.0371 19.1418 12.1178C19.1418 11.1984 18.3965 10.4531 17.4771 10.4531C16.5578 10.4531 15.8125 11.1984 15.8125 12.1178C15.8125 13.0371 16.5578 13.7824 17.4771 13.7824Z",
    fill: "#CAFFEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10819_13451"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeButton);
export default __webpack_public_path__ + "static/media/orange_button.8db35840e3b404234f05dbea1561bbec.svg";
export { ForwardRef as ReactComponent };